(function(){
  'use strict';
  var ready=function(fn){if(document.readyState!='loading'){fn()}else{document.addEventListener('DOMContentLoaded',fn)}};
  ready(function(){
    var rev=document.querySelectorAll('.tg-reveal');
    if('IntersectionObserver' in window&&rev.length){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}})},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
      rev.forEach(function(el){io.observe(el)});
    }else{rev.forEach(function(el){el.classList.add('is-in')})}
    var pb=document.querySelector('.tg-progress');
    if(pb){var onScroll=function(){var h=document.documentElement;var sc=h.scrollTop||document.body.scrollTop;var max=(h.scrollHeight-h.clientHeight)||1;pb.style.width=(sc/max*100)+'%'};window.addEventListener('scroll',onScroll,{passive:true});onScroll();}
    document.querySelectorAll('[data-tg-faq]').forEach(function(group){
      group.querySelectorAll('details.tg-faq__item').forEach(function(d){
        d.addEventListener('toggle',function(){if(d.open){group.querySelectorAll('details.tg-faq__item').forEach(function(o){if(o!==d)o.open=false})}});
      });
    });
    var satc=document.querySelector('.tg-satc');
    if(satc){
      var anchor=document.querySelector('[data-tg-atc-anchor]')||document.querySelector('product-form, .product-form, form[action*="/cart/add"]');
      var foot=document.querySelector('footer');
      var toggle=function(){
        var show=true;
        if(anchor){var r=anchor.getBoundingClientRect();if(r.bottom>0&&r.top<window.innerHeight)show=false;}
        if(foot){var rf=foot.getBoundingClientRect();if(rf.top<window.innerHeight)show=false;}
        if(window.scrollY<240)show=false;
        satc.classList.toggle('is-on',show);
      };
      window.addEventListener('scroll',toggle,{passive:true});window.addEventListener('resize',toggle);toggle();
      var sbtn=satc.querySelector('[data-tg-satc-btn]');
      if(sbtn){sbtn.addEventListener('click',function(e){
        var realBtn=document.querySelector('product-form button[type="submit"], form[action*="/cart/add"] [type="submit"], .product-form__submit, button[name="add"]');
        if(realBtn){e.preventDefault();realBtn.click();}
      });}
    }
    var nums=document.querySelectorAll('[data-tg-count]');
    if('IntersectionObserver' in window&&nums.length){
      var io2=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;io2.unobserve(e.target);var el=e.target;var end=parseFloat(el.getAttribute('data-tg-count'))||0;var suf=el.getAttribute('data-suffix')||'';var t0=null;var dur=1400;var step=function(ts){if(!t0)t0=ts;var p=Math.min((ts-t0)/dur,1);var ease=1-Math.pow(1-p,3);var v=Math.round(end*ease);el.textContent=v.toLocaleString('es-CL')+suf;if(p<1)requestAnimationFrame(step)};requestAnimationFrame(step);})},{threshold:.4});
      nums.forEach(function(n){io2.observe(n)});
    }
  });
})();
/* TG: badges de envio en tarjetas de producto (TODO el sitio) */
(function(){
  'use strict';
  var THRESH=75000;
  var MAXN=4;
  var TRUCK='<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16V6a1 1 0 0 1 1-1h9v11M13 9h4l3 3v4h-7"/><circle cx="6" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/></svg>';
  function clpInt(t){if(!t)return 0;var d=(''+t).replace(/[^0-9]/g,'');return d?parseInt(d,10):0;}
  function mk(cls,html){var b=document.createElement('div');b.className=cls;b.innerHTML=TRUCK+'<span>'+html+'</span>';return b;}
  function addBadges(){
    document.querySelectorAll('.bls__product-item').forEach(function(card){
      if(card.querySelector('.tg-card-freeship')||card.querySelector('.tg-card-getfree'))return;
      var details=card.querySelector('.bls__product-details');
      if(!details)return;
      var priceWrap=details.querySelector('.bls__product-price');
      if(!priceWrap)return;
      var cur=priceWrap.querySelector('.price__regular .price')||priceWrap.querySelector('.price');
      if(!cur)return;
      var val=clpInt(cur.textContent);
      if(val<=0)return;
      var node=null;
      if(val>=THRESH){
        node=mk('tg-card-freeship','Envío gratis RM');
      }else{
        var n=Math.ceil(THRESH/val);
        if(n>=2&&n<=MAXN){
          node=mk('tg-card-getfree','Lleva <b>'+n+'</b> y tienes envío gratis RM');
        }
      }
      if(node){priceWrap.parentNode.insertBefore(node,priceWrap.nextSibling);}
    });
    document.querySelectorAll('.tg-pcard').forEach(function(card){
      if(card.querySelector('.tg-card-getfree'))return;
      var body=card.querySelector('.tg-pcard__body');
      if(!body)return;
      var cur=card.querySelector('.tg-pcard__now');
      if(!cur)return;
      var val=clpInt(cur.textContent);
      if(val<=0||val>=THRESH)return;
      var n=Math.ceil(THRESH/val);
      if(n>=2&&n<=MAXN){
        var node=mk('tg-card-getfree','Lleva <b>'+n+'</b> y tienes envío gratis RM');
        node.style.marginTop='8px';
        body.appendChild(node);
      }
    });
  }
  function run(){try{addBadges();}catch(e){}}
  if(document.readyState!='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  ['collection:reloaded','collection:updated','facets:updated','filter:updated','pagination:updated','shopify:section:load'].forEach(function(ev){document.addEventListener(ev,function(){setTimeout(run,200);});});
  if(window.MutationObserver){
    var root=document.getElementById('MainContent')||document.body;
    var obs=new MutationObserver(function(muts){var hit=false;for(var i=0;i<muts.length;i++){if(muts[i].addedNodes&&muts[i].addedNodes.length){hit=true;break;}}if(hit){setTimeout(run,150);}});
    obs.observe(root,{childList:true,subtree:true});
  }
})();
/* TG: ficha de producto -> sellos de confianza + Ahorras $X */
(function(){
  'use strict';
  if(!/\/products\//.test(location.pathname))return;
  function clpInt(t){if(!t)return 0;var d=(''+t).replace(/[^0-9]/g,'');return d?parseInt(d,10):0;}
  function fmtCLP(n){try{return '$'+n.toLocaleString('es-CL');}catch(e){return '$'+n;}}
  var SHIELD='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 3l7 3v5c0 4.4-3 7.7-7 9-4-1.3-7-4.6-7-9V6z"/><path d="M9 12l2 2 4-4"/></svg>';
  var TRUCK2='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3 16V6a1 1 0 0 1 1-1h9v11M13 9h4l3 3v4h-7"/><circle cx="6" cy="18" r="1.5"/><circle cx="17" cy="18" r="1.5"/></svg>';
  var STORE='<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M4 9h16l-1-4H5zM5 9v10h14V9M9 19v-5h6v5"/></svg>';
  function findATC(){
    return document.querySelector('.product-form__submit')||document.querySelector('form[action*="/cart/add"] button[type="submit"]')||document.querySelector('button[name="add"]')||document.querySelector('[data-add-to-cart]');
  }
  function trustRow(){
    if(document.querySelector('.tg-trustrow'))return;
    var btn=findATC();if(!btn)return;
    var form=btn.closest('form[action*="/cart/add"]');
    var anchor=btn.closest('.product-form__buttons')||form||btn;
    var row=document.createElement('div');
    row.className='tg-trustrow';
    row.innerHTML='<span class="tg-trustrow__i">'+SHIELD+'Pago 100% seguro</span><span class="tg-trustrow__i">'+TRUCK2+'Envío gratis RM +$75.000</span><span class="tg-trustrow__i">'+STORE+'Tienda física en San Miguel</span>';
    anchor.parentNode.insertBefore(row,anchor.nextSibling);
  }
  function saveBadge(){
    var btn=findATC();if(!btn)return;
    var form=btn.closest('form[action*="/cart/add"]');
    var scope=(form&&form.closest('section,.shopify-section'))||document;
    var curEl=scope.querySelector('.price__regular .price');
    var cmpEl=scope.querySelector('.price__sale s')||scope.querySelector('s.compare-price')||scope.querySelector('.compare-price');
    var old=document.querySelector('.tg-save');if(old){old.parentNode.removeChild(old);}
    if(!curEl||!cmpEl)return;
    var cur=clpInt(curEl.textContent),cmp=clpInt(cmpEl.textContent);
    if(cmp<=cur||cur<=0)return;
    var save=cmp-cur,pct=Math.round((save/cmp)*100);
    var priceWrap=curEl.closest('.bls__price')||curEl.closest('.bls__product-price')||curEl.parentNode;
    var el=document.createElement('div');
    el.className='tg-save';
    el.innerHTML='Ahorras <b>'+fmtCLP(save)+'</b><span class="tg-save__pct">-'+pct+'%</span>';
    priceWrap.parentNode.insertBefore(el,priceWrap.nextSibling);
  }
  function run(){try{trustRow();}catch(e){}try{saveBadge();}catch(e){}}
  if(document.readyState!='loading'){run();}else{document.addEventListener('DOMContentLoaded',run);}
  document.addEventListener('shopify:section:load',function(){setTimeout(run,150);});
  document.addEventListener('change',function(e){if(e.target&&e.target.closest&&e.target.closest('form[action*="/cart/add"]')){setTimeout(saveBadge,250);}});
})();
